import { MenuItem, Text } from "@blueprintjs/core"
import React from "react"
import StaticSelector from "components/Atoms/StaticSelector"
import { useRelatedStock } from "graphql/sellable-item/sellable-item.hooks"

const AlternateStockDropdown = ({ sellableItem }) => {
  const { data } = useRelatedStock(sellableItem?.id)

  const items = data?.sellableItemStock || []

  function renderText(item) {
    const groups = item?.groupVisibility
    return item?.id ? (
      <Text>
        {item?.distributionCentre?.name}
        {groups?.length > 0 && ` | ${groups?.map(g => g.name).join(" | ")}`}
      </Text>
    ) : (
      item?.name || "--- Select ---"
    )
  }
  return (
    <div className="col-span-3">
      <StaticSelector
        fill
        label={<Text ellipsize>Related Stock - ({sellableItem?.name})</Text>}
        path="relatedStock"
        items={items}
        extraItems={[
          {
            id: null,
            name: "--- Select ---",
          },
        ]}
        renderText={renderText}
        itemRenderer={(item, { handleClick, modifiers }) => {
          return (
            <MenuItem
              active={modifiers.active}
              key={item.id}
              onClick={handleClick}
              text={renderText(item)}
              labelElement={item?.offerStockCount}
            />
          )
        }}
      />
    </div>
  )
}

export default AlternateStockDropdown
